import { Injectable } from '@angular/core';
import {
  CanActivate,
  Router,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  UrlTree
} from '@angular/router';
import { AuthService } from 'src/app/common/services/auth/auth.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  constructor(
    private authService: AuthService,
    private router: Router
  ) {}

  async canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Promise<boolean | UrlTree> {
    // If the user is logged in, allow navigation
    if (this.authService.isLoggedIn()) {
      return true;
    }

    const isLoggedIn = await this.authService.verifyAuthTokenFromQueryParams();

    // If not logged in, redirect to login
    if (!isLoggedIn) {
      const url: string = state.url || '/';
      this.authService.setRedirectUrl(url);

      // Check if the previous URL was '/app/settings/organization-settings/subscriptions'
      if (state.url === '/app/settings/organization-settings/subscriptions') {
        this.authService.setRedirectUrl(
          '/app/settings/organization-settings/subscriptions'
        );
      }

      // Extract parameters from state.url for pending invites
      const urlSegments = state.url.split('/');
      const emailIndex = urlSegments.indexOf('pending-invites') + 1;
      const inviteIdIndex = emailIndex + 1;
      const emailExistsIndex = inviteIdIndex + 1;

      const email = urlSegments[emailIndex];
      const inviteId = urlSegments[inviteIdIndex];
      const emailExists = urlSegments[emailExistsIndex];

      if (email && inviteId && emailExists) {
        if (emailExists === 'true') {
          return this.router.createUrlTree([`/auth/login/${email}/${inviteId}`]);
        } else {
          return this.router.createUrlTree([`/auth/register/${email}/${inviteId}`]);
        }
      }

      // Default redirection to login if no invite details
      return this.router.createUrlTree(['/auth/login']);
    }

    return true;
  }
}
